export class Extra {
    constructor(scene) {
        this.scene = scene;
        this.formData = this.scene.formData;
        this.modulWidth = this.formData.measuredModel.width;
        this.modulProjection = this.formData.measuredModel.projection;
        this.width = this.formData.widthValue;
        this.projection = this.formData.projectionValue;
        this.modulesX = this.formData.measuredModel.modulesX;
        this.modulesZ = this.formData.measuredModel.modulesZ;
        this.rotated = this.formData.measuredModel.rotated;
        this.width = this.formData.widthValue;
        this.projection = this.formData.projectionValue;
        this.dimension = this.scene.dimensions;
        this.createPanels();
    }
    createPanels() {
        this.createPanel();
    }
}
